import { Injectable } from '@angular/core';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import type { BannerFindInterface } from '@zaoblako/shared/modules/client/dtos/banner/banner-find.dto';
import type { BannerPageInterface } from '@zaoblako/shared/modules/client/dtos/banner/banner-page.dto';
import type { BannerQueryInterface } from '@zaoblako/shared/modules/client/dtos/banner/banner-query.dto';
import type { HistoryPageInterface } from '@zaoblako/shared/common/dtos/history/history-page.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BannerService extends BaseService {
  protected baseUrl = '/basis/client/banner';

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public findWithPagination(queryParams: BannerQueryInterface): Observable<BannerPageInterface> {
    return this.http.get<BannerPageInterface>(`${this.baseUrl}/items`, { params: this.objectToHttpParams(queryParams) });
  }

  public restoreOne(bannerId: number): Observable<BannerFindInterface> {
    return this.http.post<BannerFindInterface>(`${this.baseUrl}/${bannerId}/restore`, null);
  }

  public getHistoryById(bannerId: number, params: PaginationQueryInterface): Observable<HistoryPageInterface> {
    return this.http.get<HistoryPageInterface>(`${this.baseUrl}/${bannerId}/history`, {
      params: this.objectToHttpParams(params)
    });
  }
}
